import Stroke from 'ol/style/stroke';
import Fill from 'ol/style/fill';
import Style from 'ol/style/style';
import Circle from 'ol/style/circle';
import Feature from 'ol/feature';
import has from 'ol/has';
import {DefaultStyle} from 'ng-carta';

const pixelRatio = has.DEVICE_PIXEL_RATIO;


export class SpecialStyle extends DefaultStyle {

  public getMainStyle(feature: Feature, resolution): Style {
    return new Style({
      stroke: this.getGradientStroke(feature, 3),
      fill: new Fill({color: '#eb6f0050'})
    });
  }

  public getSelectedStyle(feature: Feature, resolution): Style {
    return new Style({
      stroke: this.getGradientStroke(feature, 4),
      fill: new Fill({color: '#eb6f00a0'})
    });
  }

  public getDrawingStyle(feature: Feature, resolution): Style {
    return new Style({
      stroke: new Stroke({color: 'rgba(255, 105, 0, 0.9)', width: 3}),
      fill: new Fill({color: '#eb6f0050'}),
      image: new Circle({
        radius: 4,
        stroke: new Stroke({color: 'rgba(255, 105, 0, 0.9)', width: 2}),
        fill: new Fill({color: 'rgba(255, 105, 0, 0.3)'})
      })
    });
  }

  private gradient(context, left, right) {
    const grad = context.createLinearGradient(left * pixelRatio, 0, right * pixelRatio, 0) as CanvasGradient;
    grad.addColorStop(0, '#ffae08');
    grad.addColorStop(7 / 10, '#e30247');
    grad.addColorStop(10 / 10, '#3a87ad');
    return grad;
  }

  private getGradientStroke(feature: Feature, width): Stroke {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const leftPixel = this.getLeftPixel(feature);
    const rightPixel = this.getRightPixel(feature);
    const gradient = this.gradient(context, leftPixel, rightPixel);
    const stroke = new Stroke({width: width});
    stroke.setColor(<any>gradient);
    return stroke;
  }

  private getLeftPixel(feature: Feature): number {
    const extent = feature.getGeometry().getExtent();
    return this.olMap.getPixelFromCoordinate([extent[0], extent[1]])[0];
  }

  private getRightPixel(feature: Feature): number {
    const extent = feature.getGeometry().getExtent();
    return this.olMap.getPixelFromCoordinate([extent[2], extent[3]])[0];
  }

}
